import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import ProductAPI from '../../../api/ProductAPI';
import Util from '../../../util/Util';
import Const from '../../../util/Constants';
import Display from '../../../util/Display';
import ApiUiController from '../../../controller/ApiUiController';

class ProductCategoryList extends React.Component {

  constructor(props) {
    super(props);
    this.categories = [];
    this.state = { ...this.state, category: {}, popup: false, inApiCall: true };

    const model = reactLocalStorage.getObject(Const.Model).product_category;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() { if (this.List) ProductAPI.listCategory(this.onReceived, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = categories => { this.categories = categories; this.setState({ inApiCall: false }); };

  show = i => {
    this.setState({
      ...this.state,
      category: { id: i === -1 ? 0 : this.categories[i].id, name: i === -1 ? '' : this.categories[i].name },
      popup: true
    });
  };
  hide = () => { this.setState({ ...this.state, popup: false }); };
  save = () => {
    if (this.state.category.name.trim().length === 0) {
      return;
    }
    this.setState({ ...this.state, popup: false, inApiCall: true });
    ProductAPI.saveCategory(this.state.category, this.success, this.onFail);
  };
  success = () => {
    Util.showNotification('Successful', 'Product Category successfully saved', 'success');
    this.props.onModuleChanged();
    ProductAPI.listCategory(this.onReceived, this.onFail);
  };
  nameChange = value => this.setState({ ...this.state, category: { ...this.state.category, name: value } });

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${this.categories[index].name}`, 'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        ProductAPI.deleteCategory(this.categories[index].id, this.onDelete, this.onFail);
      });
  };

  onDelete = () => {
    Util.showNotification('Successful', 'Product Category Deleted successfully', 'success');
    ProductAPI.listCategory(this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const categoriesUI = this.categories.map((category, _i) => (
      <tr key={`product_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{category.name}</td>
        <td>{Display.ModelLabelValue('user', category.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(category.created_date)}</td>
        <td>{Display.ModelLabelValue('user', category.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(category.updated_date)}</td>
        <td>
          {this.Update &&
            <div className="buttons success" onClick={() => this.show(_i)}><FaPencilAlt /> Update</div>
          }
          {category.status !== Const.AlwaysActive && this.Delete &&
            <div onClick={() => this.confirmDelete(_i)} className="buttons delete"><FaTrash /> Delete</div>
          }
        </td>
      </tr>
    ));

    return (
      <>
        <Modal
          show={this.state.popup} onHide={this.hide}
          size="md" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Product Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Product Category Name"
                    className="mr-sm-2"
                    value={this.state.category.name}
                    onChange={event => this.nameChange(event.target.value)} />
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer> <Button onClick={this.save}>Save</Button></Modal.Footer>
        </Modal>

        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 pb-3"><h3>Products Category</h3></div>
              {this.Add &&
                <div className="col-md-2 text-right pb-3">
                  <div className="buttons success"
                    onClick={() => this.show(-1)}>+ Add Product Category</div>
                </div>
              }
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>Created By</th>
                      <th>Created Date</th>
                      <th>Updated By</th>
                      <th>Updated Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                      {categoriesUI}
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default ProductCategoryList;